<template>
    <div :class="['mr-2', statusClass, sizeClasses]">
        {{ statusName }}
    </div>
</template>

<script>
export default {
    props: { status: {}, isRefundFromHood: false, size: { default: "md" } },

    computed: {
        statusName() {
            switch (this.status) {
                case "aborted":
                    return "Abortado";
                case "delayed":
                    return "Atrasado";
                case "authorized":
                    return "Autorizado";
                case "waiting_authentication":
                    return "Autenticação Pendente";
                case "canceled":
                    return "Cancelado";
                case "chargeback":
                    return "Chargeback";
                case "disputed":
                    return "Em Disputa";
                case "closed":
                    return "Encerrado";
                case "expired":
                    return "Expirado";
                case "error":
                    return "Incompleta";
                case "waiting_payment":
                    return "Pendente";
                case "trial":
                    return "Período de Testes";
                case "processing":
                    return "Processando";
                case "claimed":
                    return "Reclamado";
                case "refused":
                    return "Recusado";
                case "fraud_refunded":
                    return "Estornado por Fraude";
                case "chargeback_refunded":
                    return "Estornado por Chargeback";
                case "refunded":
                    if (this.isRefundFromHood) {
                        return "Reembolsado Automaticamente";
                    }
                    return "Reembolsado";
                case "refund_requested":
                    return "Reembolso Solicitado";
                case "refund_denied":
                    return "Reembolso Negado";
                default:
                    return "Em Análise";
            }
        },
        statusClass() {
            switch (this.status) {
                case "aborted":
                    return "chip-rose";
                case "delayed":
                    return "chip-slate";
                case "authorized":
                    return "chip-emerald";
                case "waiting_authentication":
                    return "chip-amber";
                case "canceled":
                    return "chip-rose";
                case "chargeback":
                    return "chip-slate";
                case "fraud_refunded":
                    return "chip-rose";
                case "chargeback_refunded":
                    return "chip-rose";
                case "disputed":
                    return "chip-amber";
                case "closed":
                    return "chip-sky";
                case "expired":
                    return "chip-slate";
                case "error":
                    return "chip-rose";
                case "waiting_payment":
                    return "chip-amber";
                case "trial":
                    return "chip-sky";
                case "processing":
                    return "chip-slate";
                case "claimed":
                    return "chip-amber";
                case "refused":
                    return "chip-rose";
                case "refunded":
                    if (this.isRefundFromHood) {
                        return "chip-rose text-[11px]";
                    }

                    return "chip-rose";
                case "refund_requested":
                    return "chip-amber";
                case "refund_denied":
                    return "chip-rose";
                default:
                    return "chip-sky";
            }
        },
        sizeClasses() {
            switch (this.size) {
                case "sm":
                    return "text-[11px] leading-tight";
                case "lg":
                    return "px-3! py-1! text-sm!";
                default:
                    return "";
            }
        },
    },
};
</script>
